var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Timer',{attrs:{"time":_vm.challengeStartedAt,"text-class":"text-theme"},model:{value:(_vm.timeRemaining),callback:function ($$v) {_vm.timeRemaining=$$v},expression:"timeRemaining"}},[_c('template',{slot:"prefix"},[_vm._v("\n    Tempo restante: \n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }